import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCustomerAuth } from '../../context/CustomerAuthContext';
import { useGalleryConfig } from '../../context/GalleryConfigContext';
import LoadingScreen from '../common/LoadingScreen';

interface CustomerProtectedRouteProps {
  children: ReactNode;
  requireVerification?: boolean;
}

const CustomerProtectedRoute: React.FC<CustomerProtectedRouteProps> = ({
  children,
  requireVerification = false,
}) => {
  const { customer, isAuthenticated, loading } = useCustomerAuth();
  const { config } = useGalleryConfig();
  const location = useLocation();

  // Show loading while auth state is being determined
  if (loading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !customer) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  // Check if email verification is required
  if (requireVerification && config?.settings.requireEmailVerification) {
    // This would check if the customer's email is verified
    // For now, we'll assume verification is handled in the auth context
  }

  return <>{children}</>;
};

export default CustomerProtectedRoute;
